document.addEventListener('variantChange', function(event) {
  var currentVariant = event.detail.variant;
  // Your custom code here
  if (currentVariant) {
    console.log('Selected variant ID is: ' + currentVariant.id);
  } else {
    console.log('No variant selected.');
  }
});


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}



$(window).on('load', function() {
  $('.prodSlider').flickity({
    cellAlign: 'left',
    contain: true
    // you can add more options here if needed
  });
});
